import { FC, useState } from "react"
import { ResponseObject } from "@coherentglobal/wasm-runner/dist/types"
import { OutputForm } from "./OutputForm"

export type OutputTabProps = {
  /**
   * Save the request so it can be displayed in the output tab
   */
  requestData: any
  /**
   * Save the response so it can be used in the output tab
   */
  responseData: ResponseObject
}

export const OutputTab: FC<OutputTabProps> = ({ requestData, responseData }) => {
  const [jsonView, setJsonView] = useState<boolean>(false)

  return (
    <>
      <div className="h-24 w-full flex items-center justify-center">
        <h1 className="w-full max-w-xs text-center text-black text-3xl font-semibold">Bond Valuation Calculator</h1>
      </div>

      <div className="flex mx-auto w-full max-w-sm space-x-2">
        <button
          className={`${
            jsonView ? "bg-form-dark text-black" : "bg-brand-light text-white"
          } rounded-l py-2 px-8 text-sm w-1/2`}
          type="button"
          onClick={() => setJsonView(false)}
        >
          FIELDS
        </button>
        <button
          className={`${
            jsonView ? "bg-brand-light text-white" : "bg-form-dark  text-black"
          } rounded-r py-2 px-8 text-sm w-1/2`}
          type="button"
          onClick={() => setJsonView(true)}
        >
          JSON VIEW
        </button>
      </div>

      {jsonView ? (
        <div className="pb-6 h-full">
          <pre className="bg-white text-sm overflow-auto rounded p-4 w-full h-full">
            {JSON.stringify(responseData, null, "\t")}
          </pre>
        </div>
      ) : (
        <>
          <OutputForm requestData={requestData} responseData={responseData} />
        </>
      )}
    </>
  )
}
